import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { LowReadyProvider } from './components/Games/Shared/context/LowReadyContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <LowReadyProvider>
        <App />
      </LowReadyProvider>
    </HashRouter>
  </React.StrictMode>
);
